import { AdminRole } from '../admin';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_ADMIN_ROLE = 'ADMIN_ROLE_';

export const AdminRoleTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.PROPELSIA_ADMIN}`]: 'Administrateur',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.SUPER_ADMIN}`]: 'Super admin',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.FINANCE}`]: 'Finance',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.SUPPORT}`]: 'Support',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.OPS}`]: 'Ops',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.READ_ONLY}`]: 'Lecture seule',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.INFOGERANCE}`]: 'Infogérance',
    [`${TRANSLATE_KEY_ADMIN_ROLE}${AdminRole.COMMUNICATION}`]: 'Communication',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(AdminRole, AdminRoleTranslation, TRANSLATE_KEY_ADMIN_ROLE, true);
